import React from 'react';
import get from 'lodash/get';
import moment from 'moment';

import useHttpStatus from '~/commons/hooks/useHttpStatus';

const ExtraReading = ({
  answer,
  extraReading,
  showTips = false,
  onExtraRead = () => {},
  assignment,
}) => {
  const [, req] = useHttpStatus();

  const extraRead = async () => {
    window.open(extraReading.url, '_blank');
    if (answer && !answer.extraReading) {
      const { assignment: aId, lv } = answer;
      const { payload } = await req({
        url: '/api/quiz/answers/extra-read',
        method: 'post',
        data: { assignment: aId, lv },
      });

      onExtraRead(payload.score);

      // google analytics
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'extraread',
          articleTitle: get(assignment, 'article.title'),
          assignmentDate: moment(assignment.date).format('YYYY-MM-DD'),
          extraReadUrl: extraReading.url,
          extraReadTitle: extraReading.title,
        });
      }
    }
  };

  return (
    <div className="my-4">
      <h4 className="mb-4">
        <img
          className="mt-n2 mr-2"
          src="/assets/img/extra-read.svg"
          style={{ width: '24px' }}
        />
        延伸學習
      </h4>
      {showTips && (
        <p>
          加分小貼士：今日事今日畢！
          當日24點前完成當天最新一期的閱讀答題，並瀏覽延伸學習，可收穫額外10分哦！
        </p>
      )}
      <div className="row">
        <div className="col-12 col-lg mb-3 mb-lg-0">
          <div
            className="position-relative"
            style={{ height: '180px' }}
          >
            <div
              className="img-bg-cover"
              style={{
                backgroundImage: `url('${extraReading.coverImg}')`,
              }}
            ></div>
          </div>
        </div>
        <div className="col">
          <div
            className="d-flex flex-column"
            style={{ minHeight: '100%' }}
          >
            <div className="flex-fill">
              <h4>{extraReading.title}</h4>
              {extraReading.caption && (
                <div className="text-justify">{extraReading.caption}</div>
              )}
            </div>
            <div className="text-right">
              <button
                target="_blank"
                rel="noopener noreferrer"
                onClick={extraRead}
                className="btn btn-light px-4 py-3"
              >
                <span className="mr-3">
                  閱讀或觀看
                </span>
                &nbsp;
                <img
                  src="/assets/img/long-arrow-right-blk.svg"
                  style={{ width: '38px', height: '9px' }}
                />
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtraReading;
